import deskService from '@/api/desk'
import { DESK } from '../types'
import strings from '@/strings'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    desks: [],
    desksCount: 0,
    pattern: '',
    availableDesks: [],
    deskWithLocation: [],
    desksBySite: [],
    desksPositions: [],
    locationsGroupedBySite: [],
    locationSiteId: null
  },
  getters: {
    desks: (state) => {
      return state.desks
    },
    desksCount: (state) => {
      return state.desksCount
    },
    pattern: (state) => {
      return state.pattern
    },
    patternDesksIsValid: (state) => {
      return state.pattern && state.pattern.length > 0 ? state.pattern.includes("#") : false
    },
    desksIsValid: (state, getters, rootState, rootGetters) => {
      return state.desksCount <= rootGetters['Client/clientDesksQuota']
    },
    everythingIsValid: (state, getters) => {
      return getters.patternDesksIsValid && getters.desksIsValid
    },
    siteLocations: (state) => {
      return state.locationsGroupedBySite.length > 0 && state.locationSiteId ? state.locationsGroupedBySite.find(site => site.id == state.locationSiteId).locations : []
    }
  },
  mutations: {
    [DESK.DESK_SET] (state, desks) {
      state.desks = desks
    },
    [DESK.DESKS_COUNT_SET](state, desksCount) {
      state.desksCount = desksCount
    },
    [DESK.PATTERN_SET](state, pattern) {
      state.pattern = pattern
    },
    [DESK.AVAILABLE_DESK_SET] (state, availableDesks) {
      state.availableDesks = []
      state.availableDesks = availableDesks
    },
    [DESK.DESK_WITH_LOCATION_SET] (state, desks) {
      state.deskWithLocation = desks
    },
    [DESK.DESKS_BY_SITE] (state, desksBySite) {
      state.desksBySite = desksBySite
    },
    [DESK.UPDATE_DESK] (state, desk) {
      state.desks.set(desk.id, desk)
    },
    [DESK.DESKS_POSITIONS] (state, desksPositions) {
      state.availableDesks = {}
      state.desksPositions = desksPositions
    },
    [DESK.SET_LOCATIONS_GROUPED_BY_SITE] (state, locationsGroupedBySite) {
      state.locationsGroupedBySite = locationsGroupedBySite
    },
    [DESK.SET_SITE_ID] (state, locationSiteId) {
      state.locationSiteId = locationSiteId
    }
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    getDesks: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        deskService.getDesks(locationId).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getInviteInformationsToBook: function (_, inviteId) {
      return new Promise((resolve, reject) => {
        deskService.getInviteInformationsToBook(inviteId).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          errorhandler.handleError(error)
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getAvailableDesks: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        deskService.getAvailableDesks(locationId)
          .then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    findAvailableDesksForManager: function ({commit}, payload) {
      return new Promise((resolve, reject) => {
        deskService.findAvailableDesksForManager(payload.siteId, payload.locationId, payload.start, payload.finish, payload.email)
          .then((response) => {
            commit(DESK.AVAILABLE_DESK_SET, response.data)
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    findAvailableDesksForTeam: function (_, payload) {
      return new Promise((resolve, reject) => {
        deskService.findAvailableDesksForTeam(payload).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async findMapWithAvailableDesksAndZones (_, payload) {
      try {
        const response = await deskService.findAvailableDesksAndZones(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    getDesksByRegion: function ({dispatch}, regionId) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskService.getDesksByRegion(regionId).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response.data)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    getLocationsGroupedBySite ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        deskService.getLocationsGroupedBySite().then((response) => {
          commit(DESK.SET_LOCATIONS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    relateDesksToRegion: function ({dispatch}, relation) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskService.relateDesksToRegion(relation).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response.data)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    async getDeskWithLocation ({commit}) {
      let response = await deskService.getDeskWithLocation()
      commit(DESK.DESK_WITH_LOCATION_SET, response.data)
    },
    updateDesk ({commit}, data) {
      commit(DESK.UPDATE_DESK, data)
    },
    async insertDesk({commit, state, dispatch, rootGetters}, desk ){
      let deskToChange = {
        active: state.desksCount >= rootGetters['Client/clientDesksQuota'] ? false : true,
        hasBookings: false,
        id: desk.feature.id_,
        locationId: desk.locationId,
        name: desk.nextDeskName,
        state: strings.pinStatus.inserted,
        x: desk.coordinates[0],
        y: desk.coordinates[1],
        bookable: true
      }
      if (deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount + 1)
      }
      await commit(DESK.UPDATE_DESK, deskToChange)

    },
    updateTextDeskStore ({commit, state}, desk) {
      let deskToChange = state.desks.get(desk.id)
      deskToChange.name = desk.name
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateActiveDeskStore ({commit, state, dispatch}, desk) {
      let deskToChange = state.desks.get(desk.id)
      if (desk.active && !deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount + 1)
      } else if(!desk.active && deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount - 1)
      }
      deskToChange.active = desk.active
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateBookableDeskStore ({commit, state}, desk) {
      let deskToChange = state.desks.get(desk.id)
      deskToChange.bookable = desk.bookable
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateCoordinatesDeskStore({commit, state}, desk) {
      let selectedDesk = state.desks.get(desk.id)
      selectedDesk.state = selectedDesk.state === strings.pinStatus.inserted ? strings.pinStatus.inserted : strings.pinStatus.updated
      selectedDesk.x = desk.coordinates[0]
      selectedDesk.y = desk.coordinates[1]
      commit(DESK.UPDATE_DESK, selectedDesk)
    },
    updateDeskCount ({commit}, count) {
      commit(DESK.DESKS_COUNT_SET, count)
    },
    setPattern ({commit}, pattern){
      commit(DESK.PATTERN_SET, pattern)
    },
    setLocationSiteId ({commit}, locationSiteId) {
      commit(DESK.SET_SITE_ID, locationSiteId)
    }
  }
}
